import React, { useState, useEffect, useRef } from "react";

import PanelTemplate from "../../templates/Panel";
import BoxTabs from "../../components/BoxTabs";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import InputEditor from "../../components/InputEditor";
import InputCheckboxes from "../../components/InputCheckboxes";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import InputColors from "../../components/InputColors";
import PageHeader from "../../components/PageHeader";
import InputTextarea from "../../components/InputTextarea";
import InputCheckboxesSublevels from "../../components/InputCheckboxesSublevels";
import api from "../../services/api";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { createOptions } from "../../helpers/selects";
import { renderError } from "../../helpers/errors";
import { toast } from "react-toastify";
import { convertIntToMoney, getBase64, getBase64Promise } from "../../helpers/conversions";
import { ModalDelete } from "../../components/ModalDelete";
import Modal from "../../components/Modal";
import ProductImagesTab from "./tabs/ImagesTab";
import { Loading } from "../../components/Loading";
import { canEditBrands, canSeeBrands, hasPermission, hasPlanFeature } from "../../services/auth";
import Icon from "../../components/Icon";
import ProductVisibility, { visibilityPayload } from "./ProductVisibility";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import ProductPriceAlert from "../../components/ProductPriceAlert";
import SubproductsTab from "./tabs/SubproductsTab";
import ProductFiscalTab from "./tabs/FiscalTab";
import ProductShippingTab from "./tabs/ShippingTab";
import PlanFeatureUpgradeButton from "../../components/PlanFeatureUpgradeButton";
import PlanFeatureUpgradeModal from "../../components/PlanFeatureUpgradeModal";

const featuredOptions = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false }
];

const ProductDetailsTab = ({
    loading,
    product, 
    sites,
    quotable,
    onVisibilityChange,
    sku, 
    setSku, 
    featured, 
    setFeatured, 
    recent, 
    setRecent, 
    name, 
    setName, 
    categories,
    setSelectedCategories,
    selectedCategories,
    description,
    setDescription, 
    techDescription, 
    setTechDescription, 
    tags, 
    tag, 
    setTag, 
    minQuantity, 
    setMinQuantity,
    updateApi,
    setUpdateApi,
    companySku,
    companyTradeName,
    setTab,
    onOpenCalculationUpgrade,
    onOpenStockUpgrade
}) => {
    return (
        <div>
            {!loading &&
            <>
                {/* <div className="row" style={{ marginBottom: 15, marginTop: 15 }}>
                    <div className="col">
                        <a href="#">Abrir no site</a>
                    </div>
                </div> */}
                <div className="row">
                    <div className="col-6">

                        <ProductVisibility
                            sites={sites}
                            quotable={quotable}
                            onChange={onVisibilityChange}
                            disabled={!hasPermission('edit_product')}
                        />

                        <h2 className="section-title">Informações gerais</h2>
                        <div className="row">
                            <div className="col-6">
                                <Input label={`Código SKU`} value={sku} change={setSku} />
                            </div>
                        </div>
                        {/* NCM, CEST, unidade, origem e GTIN saíram daqui:
                            viraram a aba "Informações fiscais" (BDM-887). */}
                        <div className="row">
                            <div className="col-6">
                                <InputSelect label={`Destaque`} options={featuredOptions} value={featured} change={setFeatured} />
                            </div>
                            <div className="col-6">
                                <InputSelect label={`Novidade`} options={featuredOptions} value={recent} change={setRecent} />
                            </div>
                        </div>

                        <Input label={`Nome do produto`} value={name} change={setName} />
                        <div className="row">
                            <div className="col-6">
                                <InputSelect label={`Selo`} options={createOptions(tags, 'text', 'id', true)} value={tag} change={setTag} null />
                            </div>
                            <div className="col-6">
                                <Input 
                                    label={`Quant. mínima`}
                                    value={minQuantity}
                                    change={setMinQuantity}
                                    mask={`convertToInt`}
                                />
                            </div>
                        </div>
                        
                        <div className="row">
                            {hasPermission('show_product_supplier_price_in_budget') &&
                                <div className="col-6">
                                    {hasPlanFeature('calculation') ? (
                                        <Input 
                                            label={`Preço a partir de`}
                                            disabled={true}
                                            value={product?.price ? convertIntToMoney(product.price, true) : 'R$ 0,00'}
                                            right={<ProductPriceAlert product={product} />}
                                        />
                                    ) : (
                                        <div className="upgrade-field">
                                            <label className="upgrade-field__label">Preço a partir de</label>
                                            <div className="upgrade-field__body">
                                                <PlanFeatureUpgradeButton onClick={onOpenCalculationUpgrade} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            }
                            <div className="col-6">
                                {hasPlanFeature('stock') ? (
                                    <Input 
                                        label={`Estoque total`}
                                        disabled={true}
                                        value={(product?.stock ?? 0).toLocaleString('pt-BR')}
                                    />
                                ) : (
                                    <div className="upgrade-field">
                                        <label className="upgrade-field__label">Estoque total</label>
                                        <div className="upgrade-field__body">
                                            <PlanFeatureUpgradeButton onClick={onOpenStockUpgrade} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>


                        <p style={{ fontSize: 14 }}>Mais detalhes de preço e estoque na aba <a href="#" onClick={e => {
                            e.preventDefault();
                            window.scrollTo(0,0);
                            setTab(2);
                        }}>cores, estoque e preço</a></p><br />

                        {hasPermission('show_product_supplier_in_budget') &&
                            <>
                                <h2 className="section-title">Atualização automática</h2>

                                <div className="row">
                                    <div className="col-6">
                                        <Input label="Fornecedor" disabled={true} value={companyTradeName} />
                                    </div>
                                    <div className="col-6">
                                        <Input label="SKU do fornecedor" disabled={true} value={companySku} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col" style={{ paddingTop: 18}}>
                                        <InputCheckboxUnique checked={updateApi} change={setUpdateApi} label={`Atualizar automaticamente nome, descrição e SEO`} />
                                        <InputCheckboxUnique checked={true} disabled={true} label={`Atualizar automaticamente ncm, preço, imagens e variações`} />
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    <div className="col-6">
                        <h2 className="section-title">Descrição do produto</h2>
                        <InputEditor value={description} change={setDescription} />

                        <h2 className="section-title">Descrição técnica</h2>
                        <InputEditor value={techDescription ?? ''} change={setTechDescription} />

                        <h2 className="section-title">Categorias</h2>
                        <InputCheckboxesSublevels
                            options={categories}
                            selecteds={selectedCategories}
                            setSelecteds={setSelectedCategories}
                        />


                    </div>
                </div>
            </>
            }
        </div>
    );
}

const KeyWordsTab = ({keywords, setKeywords}) => {
    const [showCreate, setShowCreate] = useState(false);
    const [selecteds, setSelecteds] = useState([]);
    const [keyword, setKeyword] = useState('');

    const inputRef = useRef();

    useEffect(() => {
        if (inputRef.current) {
            console.log(inputRef.current)
          inputRef.current.focus();
        }
    }, [showCreate]);

    useEffect(() => {
        if(!showCreate) clean();
    }, [showCreate]);

    const deleteKeywords = () => {
        let toKeywords = keywords.filter(k => !selecteds.includes(k));
        setKeywords(toKeywords);
    }

    const storeKeyword = () => {
        if(keywords.includes(keyword)){
            toast.info('Palavra-chave já cadastrada');
        } else {
            let toKeywords = [...keywords];
            toKeywords.push(keyword.trim());
            toKeywords.sort((a, b) => {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            setKeywords(toKeywords);
        }
        clean();
        // setShowCreate(false);
    }

    const clean = () => {
        setKeyword('');
        setSelecteds([]);
    }
    
    return (
        <>
            <Modal
                show={showCreate}
                title={`Cadastrar palavra-chave`}
                close={() => setShowCreate(false)}
                footer={
                    <Button
                        type={`primary`}
                        size={`small`}
                        svg={`save-white`}
                        text={`Cadastrar`}
                        action={storeKeyword}
                    />  
                }
            >
                <div className="section">
                    <Input 
                        inputRef={inputRef}
                        type={`text`} 
                        label={`Palavra-chave`} 
                        value={keyword} 
                        change={setKeyword}
                        action={storeKeyword}
                    />
                </div>

            </Modal>
            <div className="row">
                <div className="col-6">
                    <PageHeader
                        left={
                            <h2 className="section-title">Palavras-chave</h2>
                        }
                        right={
                            <>
                                <Button type={`primary`} size={`small`} svg={`plus-white`} text={`Cadastrar`} action={() => setShowCreate(true)} /> 
                                <Button type={`secondary`} size={`small`} svg={`delete-small`} text={`Excluir selecionadas`} action={deleteKeywords} />
                            </>
                        }
                    />
                    <InputCheckboxes 
                        options={createOptions(keywords)}
                        selecteds={selecteds}
                        setSelecteds={setSelecteds}
                    />
                </div>
            </div>
        </>
    );
}

const CustomizationsTab = ({selectedCustomizations, setSelectedCustomizations}) => {
    const [customizations, setCustomizations] = useState([]);

    useEffect(() => {
        getCustomizations();
    }, []);

    const getCustomizations = () => {
        api.get(`/customization`).then(res => {
            setCustomizations(res.data.resources);
        })
    }

    return (
        <div className="row">
            <div className="col-6">
                <h2 className="section-title">Gravações</h2>
                <InputCheckboxes 
                    options={createOptions(customizations, 'name', 'id')} 
                    selecteds={selectedCustomizations}
                    setSelecteds={setSelectedCustomizations}
                />
            </div>
        </div>
    );
}

const SeoTab = ({metaTitle, setMetaTitle, metaDescription, setMetaDescription, slug, setSlug}) => {
    return (
        <div className="row">
            <div className="col-6">
            <Input label={`Slug`} value={slug} change={setSlug} />
            <Input label={`Meta title`} value={metaTitle} change={setMetaTitle} />
            <InputTextarea label={`Meta description`} value={metaDescription} change={setMetaDescription} rows={5}/>
            </div>
        </div>
    );
}

/**
 * No produto original, as versões personalizadas que existem dele e o atalho
 * para criar uma. A versão personalizada em si nem chega aqui: a tela redireciona
 * para o editor da marca.
 */
const PersonalizedNotice = ({ product, brands, onOpenEditor }) => {
    const [showBrandPicker, setShowBrandPicker] = useState(false);
    const [brandId, setBrandId] = useState(null);
    const [creating, setCreating] = useState(false);

    const isSupplierProduct = (product.origin ?? '').startsWith('integracao');
    const versions = product.personalized_versions ?? [];

    if (!isSupplierProduct || !canSeeBrands()) return null;

    const personalize = () => {
        if (!brandId) return;
        setCreating(true);

        api.post(`/brand/${brandId}/personalize`, { product_id: product.id }).then(res => {
            onOpenEditor(brandId, res.data.resource.id);
        }).catch(error => {
            renderError(error);
            setCreating(false);
        });
    };

    return (
        <div className="product-personalized-notice">
            <Modal
                title="Personalizar para uma marca"
                show={showBrandPicker}
                close={() => setShowBrandPicker(false)}
                footer={<Button type="primary" size="small" svg="design" text="Personalizar" action={personalize} loading={creating} />}
            >
                <div className="section">
                    <InputSelect label="Marca" options={brands} value={brandId} change={setBrandId} />
                </div>
            </Modal>
            <Icon name="design" size={18} />
            <span>
                {versions.length > 0
                    ? <>
                        Versões personalizadas:{' '}
                        {versions.map((version, index) => (
                            <React.Fragment key={version.id}>
                                {index > 0 && ', '}
                                <button type="button" onClick={() => onOpenEditor(version.brand?.id, version.id)}>
                                    {version.brand?.name ?? version.name}
                                </button>
                            </React.Fragment>
                        ))}
                    </>
                    : 'Precisa deste produto com foto, nome ou descrição de uma marca? Crie uma versão personalizada; preço e estoque continuam vindo do fornecedor.'}
            </span>
            {canEditBrands() &&
                <Button type="secondary" size="small" text="Personalizar para uma marca" action={() => setShowBrandPicker(true)} />
            }
        </div>
    );
};

export const ProductEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();
    const location = useLocation();
    const hasCalculationFeature = hasPlanFeature('calculation');

    const [loading, setLoading] = useState(true);

    const [tags, setTags] = useState([]);

    const [product, setProduct] = useState(null);
    const [sites, setSites] = useState(null);
    const [quotable, setQuotable] = useState(true);
    const [sku, setSku] = useState('');
    const [ncm, setNcm] = useState('');
    const [cest, setCest] = useState('');
    const [fiscalOrigin, setFiscalOrigin] = useState('0');
    const [fiscalUnit, setFiscalUnit] = useState('UN');
    const [gtin, setGtin] = useState('');

    // Frete: milímetros e gramas, como o resto do sistema guarda.
    const [height, setHeight] = useState('');
    const [width, setWidth] = useState('');
    const [depth, setDepth] = useState('');
    const [diameter, setDiameter] = useState('');
    const [weight, setWeight] = useState('');
    const [netWeight, setNetWeight] = useState('');
    const [featured, setFeatured] = useState(false);
    const [recent, setRecent] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [techDescription, setTechDescription] = useState('');
    const [tag, setTag] = useState(null);
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [slug, setSlug] = useState('');
    const [minQuantity, setMinQuantity] = useState(1);
    const [updateApi, setUpdateApi] = useState(false);
    const [companySku, setCompanySku] = useState('');
    const [companyTradeName, setCompanyTradeName] = useState('');
    const [hasSubproducts, setHasSubproducts] = useState(false);

    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [subproducts, setSubproducts] = useState([]);
    const [keywords, setKeywords] = useState([]);
    const [selectedCustomizations, setSelectedCustomizations] = useState([]);

    const [confirmDelete, setConfirmDelete] = useState(false);
    const [upgradeFeature, setUpgradeFeature] = useState(null);

    const [tab, setTab] = useState(0);


    useEffect(() => {
        getCategories();
        getBrands();
        getTags();
        getProduct();
    }, []);

    const getProduct = () => {
        setLoading(true);
        api.get(`/product/${id}/sites`).then(res => setSites(res.data.resource)).catch(() => {});
        api.get(`/product/${id}`).then(res => {
            let resource = res.data.resource;

            // A versão personalizada se edita no editor da marca: o que ela herda
            // do original voltaria a ser do original ao salvar aqui.
            const personalizedBrand = resource.personalized?.brand;
            if (personalizedBrand) {
                const returnTo = new URLSearchParams(location.search).get('return_to');
                navigete(
                    `/brand/${personalizedBrand.id}/personalized/${id}${returnTo ? `?return_to=${encodeURIComponent(returnTo)}` : ''}`,
                    { replace: true }
                );
                return;
            }

            let toSelectedCategories = [];
            resource.categories.map(category => toSelectedCategories.push(category.id));
            setProduct(resource);
            setSelectedCategories(toSelectedCategories);
            setSelectedCustomizations(resource.customization_ids);
            setQuotable(resource.quotable ?? true);
            setSku(resource.sku);
            setNcm(resource.ncm);
            setCest(resource.cest ?? '');
            setFiscalOrigin(resource.fiscal_origin ?? '0');
            setFiscalUnit(resource.fiscal_unit ?? 'UN');
            setGtin(resource.gtin ?? '');
            setHeight(resource.height ?? '');
            setWidth(resource.width ?? '');
            setDepth(resource.depth ?? '');
            setDiameter(resource.diameter ?? '');
            setWeight(resource.weight ?? '');
            setNetWeight(resource.net_weight ?? '');
            setFeatured(resource.featured);
            setRecent(resource.recent);
            setName(resource.name);
            setDescription(resource.description);
            setTechDescription(resource.tech_description);
            setTag(resource.tag_id);
            setMetaTitle(resource.meta_title ?? "");
            setMetaDescription(resource.meta_description ?? "");
            setSlug(resource.slug);
            setMinQuantity(resource.min_quantity);
            setUpdateApi(resource.update_api);
            setCompanySku(resource.company_sku);
            setCompanyTradeName(resource.company_trade_name);
            setSubproducts(resource.subproducts);
            setHasSubproducts(resource.has_subproducts);
            setKeywords(resource.keywords ?? []);

        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const getTags = () => {
        api.get(`/tag`).then(res => {
            setTags(res.data.resources);
        });
    }

    const getCategories = () => {
        api.get(`/category`).then(res => {
            let toCategories = [];

            res.data.resources.map(category => {
                let options = [];

                category.categories.map(subcategory => {
                    options.push({
                        label: subcategory.name,
                        value: subcategory.id
                    })
                });
                toCategories.push({
                    label: category.name,
                    value: category.id,
                    options
                })
            })
            setCategories(toCategories);
        });
    }

    const getBrands = () => {
        if (!canSeeBrands()) return;

        api.get(`/brand?per_page=100`).then(res => {
            const resources = res.data.resources?.data ?? res.data.resources ?? [];
            setBrands(resources.map(brand => ({ label: brand.name, value: brand.id })));
        }).catch(() => {});
    }

    const updateProduct = () => {
        setLoading(true);

        api.put(`/product/${id}`, {
            quotable,
            visibility: visibilityPayload(sites),
            featured,
            recent,
            name,
            sku,
            ncm,
            cest: cest || null,
            fiscal_origin: fiscalOrigin || null,
            fiscal_unit: fiscalUnit || null,
            gtin: gtin || null,
            height: height === '' ? null : parseInt(height, 10),
            width: width === '' ? null : parseInt(width, 10),
            depth: depth === '' ? null : parseInt(depth, 10),
            diameter: diameter === '' ? null : parseInt(diameter, 10),
            weight: weight === '' ? null : parseInt(weight, 10),
            net_weight: netWeight === '' ? null : parseInt(netWeight, 10),
            description,
            tech_description: techDescription,
            categories: selectedCategories,
            keywords,
            customizations: selectedCustomizations,
            tag_id: tag,
            subproducts,
            meta_title: metaTitle,
            meta_description: metaDescription,
            slug,
            min_quantity: minQuantity,
            update_api: updateApi,
            has_subproducts: hasSubproducts
        }).then(res => {
            toast.success('Produto atualizado com sucesso');
            getProduct();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const deleteProduct = () => {
        setLoading(true);

        api.delete(`/product/${id}`).then(res => {
            navigete(getProductListReturnUrl());
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getProductListReturnUrl = () => {
        const params = new URLSearchParams(location.search);
        const returnTo = params.get('return_to');

        return returnTo && (returnTo.startsWith('/product/list') || returnTo.startsWith('/brand/edit/')) ? returnTo : '/product/list';
    }

    const returnTo = new URLSearchParams(location.search).get('return_to');
    const backToBrand = returnTo?.startsWith('/brand/edit/') ? returnTo : null;

    const tabs = [
        {
            title: 'Detalhes dos produtos',
            content: (
                <ProductDetailsTab
                    loading={loading}
                    product={product}
                    sites={sites}
                    quotable={quotable}
                    onVisibilityChange={({ sites: nextSites, quotable: nextQuotable }) => {
                        setSites(nextSites);
                        setQuotable(nextQuotable);
                    }}
                    sku={sku}
                    setSku={setSku}
                    featured={featured}
                    setFeatured={setFeatured}
                    recent={recent}
                    setRecent={setRecent}
                    name={name}
                    setName={setName}
                    categories={categories}
                    setSelectedCategories={setSelectedCategories}
                    selectedCategories={selectedCategories}
                    setDescription={setDescription}
                    description={description}
                    setTechDescription={setTechDescription}
                    techDescription={techDescription}
                    tags={tags}
                    tag={tag}
                    setTag={setTag}
                    minQuantity={minQuantity}
                    setMinQuantity={setMinQuantity}
                    updateApi={updateApi}
                    setUpdateApi={setUpdateApi}
                    companySku={companySku}
                    companyTradeName={companyTradeName}
                    setTab={setTab}
                    onOpenCalculationUpgrade={() => setUpgradeFeature('calculation')}
                    onOpenStockUpgrade={() => setUpgradeFeature('stock')}
                />
            )
        },
        {
            title: 'Informações fiscais',
            content: (
                <ProductFiscalTab
                    ncm={ncm}
                    setNcm={setNcm}
                    cest={cest}
                    setCest={setCest}
                    fiscalOrigin={fiscalOrigin}
                    setFiscalOrigin={setFiscalOrigin}
                    fiscalUnit={fiscalUnit}
                    setFiscalUnit={setFiscalUnit}
                    gtin={gtin}
                    setGtin={setGtin}
                />
            )
        },
        {
            title: 'Frete',
            content: (
                <ProductShippingTab
                    height={height}
                    setHeight={setHeight}
                    width={width}
                    setWidth={setWidth}
                    depth={depth}
                    setDepth={setDepth}
                    diameter={diameter}
                    setDiameter={setDiameter}
                    weight={weight}
                    setWeight={setWeight}
                    netWeight={netWeight}
                    setNetWeight={setNetWeight}
                />
            )
        },
        {
            title: 'Imagens',
            content: (
                <ProductImagesTab
                    product={product}
                    setProduct={setProduct}
                />
            )
        },
        {
            title: 'Cores, estoque e preço',
            content: (
                <SubproductsTab
                    product={product}
                    sku={sku}
                    subproducts={subproducts}
                    setSubproducts={setSubproducts}
                    hasSubproducts={hasSubproducts}
                    setHasSubproducts={setHasSubproducts}
                />
            )
        },
        {
            title: 'Palavras-chave',
            content: (
                <KeyWordsTab
                    keywords={keywords}
                    setKeywords={setKeywords}
                />
            )
        },
        ...(hasCalculationFeature ? [{
            title: 'Gravações',
            content: (
                <CustomizationsTab
                    product={product}
                    selectedCustomizations={selectedCustomizations}
                    setSelectedCustomizations={setSelectedCustomizations}
                />
            )
        }] : []),
        {
            title: 'SEO',
            content: (
                <SeoTab
                    metaTitle={metaTitle}
                    setMetaTitle={setMetaTitle}
                    metaDescription={metaDescription}
                    setMetaDescription={setMetaDescription}
                    slug={slug}
                    setSlug={setSlug}
                />
            )
        }
    ];

    return (
        <>
            <ModalDelete
                show={confirmDelete}
                action={deleteProduct}
                loading={loading}
                close={() => setConfirmDelete(false)}
            />
            <PlanFeatureUpgradeModal
                feature={upgradeFeature}
                show={upgradeFeature !== null}
                close={() => setUpgradeFeature(null)}
            />
            <PanelTemplate id="product-edit">
                <Loading show={loading} />
                {!loading && product !== null &&
                    <>
                        {backToBrand &&
                            <div className="product-brand-context">
                                <span>Você veio da aba Produtos da marca.</span>
                                <Link to={backToBrand}>Voltar para a marca</Link>
                            </div>
                        }
                        <PersonalizedNotice
                            product={product}
                            brands={brands}
                            onOpenEditor={(brandId, productId) => navigete(`/brand/${brandId}/personalized/${productId}`)}
                        />
                        <BoxTabs
                            titles={tabs.map(tabItem => tabItem.title)}
                            tab={tab}
                            setTab={setTab}
                            contents={tabs.map(tabItem => tabItem.content)}
                        />
                        <PageFooter spaceBetween={true}>
                            <>
                                {hasPermission('edit_product') &&
                                    <Button
                                    type={`primary`}
                                    size={`small`}
                                    svg={`save-white`}
                                    text={`Salvar alterações`}
                                    action={updateProduct}
                                    loading={loading}
                                    />
                                }
                                {hasPermission('delete_product') &&
                                    <Button
                                    type={`secondary`}
                                    size={`small`}
                                    svg={`delete-small`}
                                    text={`Excluir`}
                                    action={() => setConfirmDelete(true)}
                                    loading={loading}
                                    />
                                }
                            </>
                        </PageFooter>
                    </>
                }
            </PanelTemplate>
        </>
    );
}

export default ProductEdit;
